var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("search-page", {
        directives: [
          {
            name: "hasPermi",
            rawName: "v-hasPermi",
            value: ["platform:task:statistics:list"],
            expression: "['platform:task:statistics:list']",
          },
        ],
        ref: "searchPage",
        attrs: {
          "form-data": _vm.formData,
          columns: _vm.columns,
          request: _vm.getList,
        },
        scopedSlots: _vm._u([
          {
            key: "table-application",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "div",
                  [
                    _c("div", [_vm._v(_vm._s(row.applicationName))]),
                    _c(
                      "el-tag",
                      { staticClass: "table-tag", attrs: { type: "info" } },
                      [_vm._v("ID：" + _vm._s(row.applicationId))]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "table-append",
            fn: function () {
              return [
                _c("el-table-column", {
                  attrs: {
                    fixed: "right",
                    label: "操作",
                    align: "center",
                    "min-width": "220",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _c(
                            "p",
                            [
                              _c(
                                "span",
                                { staticStyle: { "padding-right": "5px" } },
                                [_vm._v("操作")]
                              ),
                              _c("right-toolbar", {
                                attrs: { columns: _vm.columns },
                                on: { refresh: _vm.refreshList },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "hasPermi",
                                  rawName: "v-hasPermi",
                                  value: ["platform:task:statistics:detail"],
                                  expression:
                                    "['platform:task:statistics:detail']",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.handleDetail(row)
                                },
                              },
                            },
                            [_vm._v("查看明细")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("statistics-detail", {
        attrs: {
          "app-id": _vm.detail.appId,
          "task-code": _vm.detail.taskCode,
          "task-type": _vm.detail.taskType,
          "stat-date": _vm.detail.statDate,
        },
        model: {
          value: _vm.detail.show,
          callback: function ($$v) {
            _vm.$set(_vm.detail, "show", $$v)
          },
          expression: "detail.show",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }